export enum AccessType {
  SuperAdmin = 'Super Admin',
  Admin = 'Admin',
  Readonly = 'Viewing',
  NoAccess = 'No Access',
}
